import React from "react";

const Charger = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path  className="u_fill"
            fill={fill}
            fillRule="evenodd"
            d="M21.188 32v1.24a.777.777 0 0 1-.213.537.714.714 0 0 1-.516.223h-4.918a.714.714 0 0 1-.516-.223.777.777 0 0 1-.213-.537V32h6.376ZM15.234 6.024v2.73h-2.01v-2.73h2.01Zm7.542 0v2.73h-2.01v-2.73h2.01Zm0-3.214v2.154h-2.01V2.81c0-.215.095-.421.263-.573A.95.95 0 0 1 21.664 2h.215c.238 0 .466.086.634.238a.774.774 0 0 1 .263.573Zm-7.542 0v2.154h-2.01V2.81c0-.215.094-.421.263-.573A.949.949 0 0 1 14.122 2h.214a.95.95 0 0 1 .635.238.774.774 0 0 1 .263.573Zm-5.042 10.095v-1.461c0-.666.519-1.207 1.157-1.207h13.302c.639 0 1.157.541 1.157 1.207v1.461H10.192ZM28 15.753v12.87c0 1.044-.813 1.892-1.815 1.892H9.815C8.813 30.515 8 29.667 8 28.622V15.753c0-1.044.813-1.893 1.815-1.893h16.37c1.002 0 1.815.849 1.815 1.893Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Charger;